import Decimal from 'decimal.js'

import { currencyToNumber, isValidAmount } from 'modules/core/lib/formatCurrencyUtils'

const CENT = 100

export const amountInCent = (amount: string | number | undefined | null) => {
  if (!isValidAmount(amount as string) || !amount) return null

  return new Decimal(currencyToNumber(amount)).times(CENT)
}
